export const summersunflower = {
  name: 'Summer Sunflower',
  color: [0.48627450980392156, 0.6666666666666666, 0.17647058823529413, 1],
  bg: [0.30196078431372547, 0.5215686274509804, 0.7411764705882353, 1],
  grid1: [1, 0.7333333333333333, 0, 1],
  grid2: [0.796078431372549, 0.38823529411764707, 0.09411764705882353, 1],
}
